import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-modal-footer',
  imports: [],
  templateUrl: './modal-footer.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './modal-footer.component.scss'
})
export class ModalFooterComponent {

}